import { render, staticRenderFns } from "./IndicatorWithSubtitleH2.vue?vue&type=template&id=230d7b42&"
import script from "./IndicatorWithSubtitleH2.vue?vue&type=script&lang=js&"
export * from "./IndicatorWithSubtitleH2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "IndicatorWithSubtitleH2.vue"
export default component.exports